(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6436],{

/***/ 4776:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publish/pricing",
      function () {
        return __webpack_require__(7857);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SiteBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86542);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76195);
/* harmony import */ var datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62338);



function SiteBanner(param) {
    var content = param.content, enabled = param.enabled;
    return enabled && !(0,datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEmptyDocument */ .RL)(content) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-stealth-bomber text-white px-7 py-4 flex justify-center text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_2__/* .StructuredText */ .rZ, {
            data: content,
            customMarkRules: [
                (0,react_datocms__WEBPACK_IMPORTED_MODULE_3__/* .renderMarkRule */ .zf)("strong", function(param) {
                    var children = param.children, key = param.key;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        className: "font-medium",
                        children: children
                    }, key);
                }), 
            ]
        })
    }) : null;
}



/***/ }),

/***/ 7857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63430);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12569);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8814);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80338);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26499);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88038);
/* harmony import */ var _modules_site_banner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6985);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20978);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67199);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_9__);













var PricingPage = function(param) {
    var plans = param.plans, preview = param.preview, subscription = param.subscription;
    var ref = (0,react_datocms__WEBPACK_IMPORTED_MODULE_10__/* .useQuerySubscription */ .L)(subscription), tmp = ref.data, ref1 = tmp === void 0 ? {} : tmp, page = ref1.page, banner = ref1.banner;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_api__WEBPACK_IMPORTED_MODULE_3__/* .ProductInterval.Year */ .g7.Year), interval = ref2[0], setInterval = ref2[1];
    var handleIntervalChange = function(interval) {
        return setInterval(interval);
    };
    if (!page) return null;
    var modules = page.modules, seo = page.seo;
    var handleClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var planID, interval;
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        planID = param.planID, interval = param.interval;
                        if (planID === _config__WEBPACK_IMPORTED_MODULE_5__/* .PUBLISH_TRIAL_PLAN_ID */ .H2) {
                            window.location.href = (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .createUrl */ .uJ)(_config__WEBPACK_IMPORTED_MODULE_5__/* .EXTERNAL.PUBLISH.GET_STARTED.HREF */ .IK.PUBLISH.GET_STARTED.HREF, {
                                backPath: "/subscriptions"
                            });
                        } else {
                            window.location.href = "".concat((0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .createUrl */ .uJ)(_config__WEBPACK_IMPORTED_MODULE_5__/* .EXTERNAL.SIGN_UP.HREF */ .IK.SIGN_UP.HREF, {
                                planID: planID,
                                interval: interval,
                                product: "publish",
                                backPath: "/checkout"
                            }));
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClick(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Layout */ .Ar, {
        product: "publish",
        preview: preview,
        siteBanner: banner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_modules_site_banner__WEBPACK_IMPORTED_MODULE_7__/* .SiteBanner */ .b, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, banner)) : null,
        className: "overflow-hidden",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .SEO */ .HJ, {
                title: "Publish plans | Publish",
                children: (0,react_datocms__WEBPACK_IMPORTED_MODULE_13__/* .renderMetaTags */ .y)(seo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                isFirstSection: true,
                className: "mb-28",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_9__.Pricing, {
                        title: "Supercharge your website’s content",
                        productName: _api__WEBPACK_IMPORTED_MODULE_3__/* .ProductName.Publish */ .rZ.Publish,
                        onIntervalChange: handleIntervalChange,
                        children: plans.map(function(param) {
                            var id = param.id, attributes = param.attributes;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_9__.Pricing.Item, {
                                id: id,
                                darkMode: // IS_BLACK_FRIDAY &&
                                // attributes.slug === PUBLISH_LIVE_PLAN_SLUGS.pro &&
                                // interval === ProductInterval.Year
                                false,
                                yearlyPrice: attributes["yearly-price"] / 12,
                                billingInfo: attributes["yearly-price"] === 0 ? "No credit card needed" : "USD per month, billed ".concat(interval, "ly"),
                                monthlyPrice: attributes["monthly-price"],
                                yearlyDiscount: undefined,
                                features: attributes.features,
                                onClick: handleClick,
                                disableSale: attributes["monthly-price"] === 0,
                                children: attributes.name
                            }, id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "-mt-12 md:-mt-16 lg:-mt-20 xl:-mt-30",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_modules__WEBPACK_IMPORTED_MODULE_6__/* .ModuleToComponent */ .WT, {
                    modules: modules
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PricingPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(4776); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);